import { FacetList, FacetWithKey } from 'contexts/elasticModels';

export const setCurrentFacetsList = (facets: FacetList | null): FacetWithKey[] | null => {
  if (!facets) return null;
  const facetsArray: FacetWithKey[] = [];

  Object.keys(facets).forEach((key) => {
    facets[key].forEach((facetValue) => {
      if (facetValue.isRefined) {
        facetsArray.push({ ...facetValue, key });
      }
    });
  });

  return facetsArray;
};

export default setCurrentFacetsList;
